import { Fragment, FunctionComponent } from "react";

export const NonBreakingSpace: FunctionComponent = () => <Fragment>{`\u00A0`}</Fragment>;
export const Ampersand: FunctionComponent = () => <Fragment>{`\u0026`}</Fragment>;
